import { sprintf } from 'sprintf-js';

import type { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';

import { OrgLogoLink } from './ListingViewSidebarImage.styled';

type Props = {
  isPostedAnonymously: boolean;
  orgLogoOverride?: ApiFilestackImageData | null;
  orgLogo?: ApiFilestackImageData | null;
  orgName: string | undefined;
  orgURLForCurrentLocale?: string | null;
};

export function ListingViewSidebarImage({
  isPostedAnonymously,
  orgLogo,
  orgLogoOverride,
  orgName,
  orgURLForCurrentLocale,
}: Props) {
  const imageElement = (
    <FilestackImage
      data-qa-id="org-logo"
      width={180}
      height={128}
      data={orgLogoOverride || (isPostedAnonymously ? null : orgLogo) || null}
      alt={sprintf(getText('Logo of %(orgName)s'), { orgName })}
      objectPosition="left"
      noCrop
    />
  );

  return (
    (orgLogo || orgLogoOverride) && (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {orgURLForCurrentLocale ? (
          <OrgLogoLink to={`${orgURLForCurrentLocale}`}>
            {imageElement}
          </OrgLogoLink>
        ) : (
          imageElement
        )}
      </>
    )
  );
}
